// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QXiq","title":"styles_title__3V34_"};